export { NewsletterCard } from "./NewsletterCard"
export type { NewsletterCardProps } from "./NewsletterCard"
